import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { pickLoc } from '../../lib/collections';
import type { CollectionTypeDef } from '../../lib/types';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

// Campo Puck para elegir qué colección pinta el bloque CollectionSection. Carga
// las colecciones activas del tenant (/api/collection-types) y las ofrece por su
// etiqueta amigable — el usuario nunca ve la palabra "colección".
export default function CollectionKeyField({ value, onChange }: Props) {
  const [types, setTypes] = useState<CollectionTypeDef[]>([]);

  useEffect(() => {
    api.collectionTypes.list().then(setTypes).catch(() => setTypes([]));
  }, []);

  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: '100%', background: 'rgb(var(--ui-bg-ch))', border: '1px solid rgb(var(--ui-border-ch))',
        borderRadius: 6, padding: '8px 10px', fontSize: 13, color: 'rgb(var(--ui-text-ch))',
      }}
    >
      <option value="">Elige una sección…</option>
      {types.map((t) => (
        <option key={t.key} value={t.key}>{pickLoc(t.labels.plural, 'es') || t.key}</option>
      ))}
    </select>
  );
}
